import axios from 'axios';
import { apiConfig } from '@entities/requests';

export const backendURL = import.meta.env.VITE_SERVER_URL;

export const checkRegion = async () => {
  const { data } = await axios.get(`${backendURL}/api/region-availability`, apiConfig);
  return data;
};
